<template>
<div>
    <h1> Its Share price of companies </h1>

    <p> Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis cupiditate quod, eos libero doloremque, reiciendis dignissimos incidunt quae error perferendis, optio provident quo sint quis voluptatem quisquam aliquam fuga? Praesentium, pariatur? Soluta nostrum esse distinctio autem voluptates laborum ratione velit, labore dolor molestiae, accusantium assumenda eveniet ut facere ea amet rem voluptate deserunt repellendus numquam culpa. Itaque molestiae cum voluptatibus inventore facilis doloremque iusto blanditiis, alias dolorem fuga optio ullam qui distinctio possimus? Voluptates quisquam nisi libero neque possimus sunt, velit ut recusandae placeat officia soluta animi et unde eligendi odit facere voluptate reprehenderit error, quo temporibus. Quo, saepe quos?  </p>
</div>


</template>

<script>
export default {
  name: 'SharePrice',
  data() {
    return {
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
